import { SelectProps } from "@cofano/cck/Select/Select";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { ReferenceAdjustmentType } from "__generated__/graphql";

const ReferenceRateAdjustmentTypeSelect = ({ value, onChange }: Omit<SelectProps<ReferenceAdjustmentType, false>, "fetchOptions">) => {
	return (
		<Select
			fetchOptions={Object.values(ReferenceAdjustmentType)}
			getOptionLabel={(option) => intl.formatMessage({ id: `REFERENCE_RATE_ADJUSTMENT_TYPE_${option}` })}
			value={value}
			onChange={onChange}
		/>
	);
};

export default ReferenceRateAdjustmentTypeSelect;
